const actions = {
  SET_STATE: 'config/SET_STATE',
  TOGGLE_SIDEBAR: 'config/TOGGLE_SIDEBAR'
};

export default actions
